import Rest from '../Rest'

export default class NewsletterWorkflowService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/newsletter_workflows'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  clone(id: Number, data: any = null) {
    return this.post(`/${id}/clone`, data)
  }

  saveTimeline(id: Number, data: any = null) {
    return this.post(`/${id}/timelines`, data)
  }

  getAllTimelines(id: Number) {
    return this.get(`/${id}/timelines`)
  }

  deleteTimeline(id: Number, timelineId: Number) {
    return this.delete(`/${id}/timelines/${timelineId}`)
  }

  //
  addDestination(id: Number, data: any = null) {
    return this.post(`/${id}/destinations`, {
      destinations: data
    })
  }

  deleteDestination(id: Number, destinationId: Number) {
    return this.delete(`/${id}/destinations/${destinationId}`)
  }

  dispatch(workflowId: Number) {
    return this.post(`/${workflowId}/dispatch`)
  }

  dispatchReport(workflowId: Number, destinationId: Number) {
    const destinations = [destinationId]
    return this.post(`/${workflowId}/destinations/${destinationId}/dispatch`, {
      destinations: destinations
    })
  }

  generateReportCheckpoint(workflowId: Number, timelineId: Number, checkpointId: Number) {
    return this.get(`/${workflowId}/timelines/${timelineId}/checkpoints/${checkpointId}/generate_report`)
  }

  sendCheckpointReport(workflowId: Number, timelineId: Number, checkpointId: Number, mediaId: Number) {
    return this.get(`/${workflowId}/timelines/${timelineId}/checkpoints/${checkpointId}/${mediaId}/send_report`)
  }

}
